'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconThreeDotsLine, iconThreeDotsLineTag } from '@ni/nimble-components/dist/esm/icons/three-dots-line';
import { wrap } from '../../utilities/react-wrapper';

export type { IconThreeDotsLine };
export { iconThreeDotsLineTag };
export const NimbleIconThreeDotsLine = wrap(IconThreeDotsLine);